<template>
  <div>
    <Head :title="$t('auth.login.title')" />

    <div class="rounded-lg bg-white p-16 text-center">
      <div class="title text-2xl font-bold">{{ $t('auth.login.loginAccount') }}</div>
      <div class="to-register mt-2 text-lg">
        {{ $t('auth.login.noAccount') }}
        <Link class="font-bold text-primary" :href="'#'">{{ $t('auth.login.goToRegister') }}</Link>
      </div>

      <el-divider />

      <el-form :model="form" label-position="top" class="mx-auto !w-[360px] text-left" size="large" @submit.prevent="submit">
        <el-form-item prop="email" :label="$t('auth.login.email')"
          :rules="[{ required: true, message: $t('auth.login.emailPlaceholder'), trigger: 'blur' }]">
          <el-input v-model="form.email" :placeholder="$t('auth.login.emailPlaceholder')" />
        </el-form-item>

        <el-form-item prop="password" :label="$t('auth.login.password')"
          :rules="[{ required: true, message: $t('auth.login.passwordPlaceholder'), trigger: 'blur' }]">
          <el-input v-model="form.password" type="password" :placeholder="$t('auth.login.passwordPlaceholder')" />
        </el-form-item>

        <div class="flex items-center justify-between mb-4">
          <el-checkbox v-model="form.remember">{{ $t('auth.login.rememberMe') }}</el-checkbox>
          <Link class="text-primary" :href="'#'">{{ $t('auth.login.forgotPassword') }}</Link>
        </div>

        <el-button type="primary" class="mt-4 w-full" size="large" native-type="submit" :loading="form.processing">{{ $t('auth.login.submit') }}</el-button>
      </el-form>
    </div>
  </div>
</template>

<script setup>
import { Link, Head } from "@inertiajs/vue3"
import { usePostHog } from "@/hooks/usePostHog"

const page = usePage()
const { triggerAlert } = useFlash(page.props.flash, { useWatch: false })
const { capture, captureFormSubmit } = usePostHog()

const form = useForm({
  email: "",
  password: "",
  remember: false,
})

const submit = () => {
  capture('login_form_submitted', { email: form.email })

  form.post(routes.session(), {
    onSuccess: (resp) => {
      captureFormSubmit('login', true)
      triggerAlert(resp?.props?.flash)
    },
    onError: (errors) => {
      captureFormSubmit('login', false, { errors: Object.keys(errors) })
    }
  })
}
</script>

<script>
export default { layout: Minimal }
</script>
